function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Track_Shipment_Icon",
  transform: "translate(-98.443 -744.432)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1129",
  d: "M194.908,682.121l-3.62-3.825a6.4,6.4,0,0,1-5.562,1.23,6.166,6.166,0,0,1-3.672-2.581,6.289,6.289,0,0,1,9.329-8.271c2.576,2.256,2.908,5.67.765,8.748l3.832,3.63v1.07Zm-7.662-13.7a5,5,0,1,0,5.022,4.924A5.016,5.016,0,0,0,187.245,668.419Z",
  transform: "translate(-67.536 92.311)",
  fill: "#4550e5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1130",
  d: "M112.755,603.928v3.691c0,2.495.03,4.99-.016,7.484-.016.859.3,1.112,1.12,1.1,2.5-.037,4.995-.014,7.492-.011a1.933,1.933,0,0,1,.841.059c.239.127.526.443.519.668-.006.194-.38.511-.618.539a18.12,18.12,0,0,1-2.031.032c-2.105,0-4.21.015-6.315-.005-1.63-.016-2.257-.656-2.259-2.271-.006-3.742-.037-7.485.032-11.227a3.134,3.134,0,0,1,.751-1.859,40.743,40.743,0,0,1,3.707-3.7,3.7,3.7,0,0,1,2.051-.864,53.325,53.325,0,0,1,5.776-.006,3.086,3.086,0,0,1,1.788.727c1.4,1.265,2.735,2.612,4.011,4a2.82,2.82,0,0,1,.648,1.606,31.511,31.511,0,0,1,0,3.952c-.018.322-.411.623-.632.934-.212-.3-.585-.595-.607-.911-.076-1.1-.047-2.208-.024-3.313.011-.534-.159-.769-.732-.767-5.03.017-10.06.014-15.09.021A1.987,1.987,0,0,0,112.755,603.928Zm7.393-5.077c-.982,0-2.127-.351-2.7.071a28.405,28.405,0,0,0-3.421,3.467h6.121Zm7.523,3.551.138-.251a19.826,19.826,0,0,1-2.309-2.219c-1.09-1.431-2.475-1.2-3.908-1.061V602.4Z",
  transform: "translate(-13.033 146.951)",
  fill: "#4550e5"
}));

var SvgTrack = function SvgTrack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/track.46fdf4f7.svg";
export { ForwardRef as ReactComponent };